import React from 'react';
import './Gallery.css';

const Gallery = () => {
  const productionImages = Array(6).fill(null);
  const facilityImages = Array(6).fill(null);

  return (
    <div className="gallery">
      <section className="gallery-hero hero-section">
        <div className="container">
          <h1>Our Gallery</h1>
          <p>Take a behind-the-scenes look at our production facility and products</p>
        </div>
      </section>

      <section className="video-section">
        <div className="container">
          <div className="section-title">
            <h2>Production Facility Tour</h2>
            <p>See how we maintain the highest standards in feed production</p>
          </div>
          
          <div className="video-container">
            <div className="video-placeholder">
              <i className="fas fa-play-circle"></i>
              <h3>Ramson Feeds Production Process</h3>
              <p>Click to play the video tour of our facility</p>
            </div>
          </div>
        </div>
      </section>

      <section className="production-gallery">
        <div className="container">
          <div className="section-title">
            <h2>Production Images</h2>
            <p>Our state-of-the-art manufacturing process</p>
          </div>
          
          <div className="gallery-grid">
            {productionImages.map((_, index) => (
              <div key={index} className="gallery-item">
                <div className="gallery-image">
                  Production Image {index + 1}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="facility-gallery">
        <div className="container">
          <div className="section-title">
            <h2>Facility & Equipment</h2>
            <p>Our modern infrastructure ensures quality at every step</p>
          </div>
          
          <div className="gallery-grid">
            {facilityImages.map((_, index) => (
              <div key={index} className="gallery-item">
                <div className="gallery-image">
                  Facility Image {index + 1}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="quality-section">
        <div className="container">
          <div className="quality-content">
            <div className="quality-text">
              <h2>Quality Assurance</h2>
              <p>Every batch of feed produced at Ramson Feeds undergoes rigorous quality checks to ensure it meets our high standards and your expectations.</p>
              
              <div className="quality-features">
                <div className="feature">
                  <i className="fas fa-microscope"></i>
                  <span>Laboratory Testing</span>
                </div>
                <div className="feature">
                  <i className="fas fa-clipboard-check"></i>
                  <span>Quality Control</span>
                </div>
                <div className="feature">
                  <i className="fas fa-certificate"></i>
                  <span>Certification</span>
                </div>
              </div>
            </div>
            
            <div className="quality-image">
              <div className="image-placeholder">
                <i className="fas fa-award"></i>
                <p>Quality Assurance</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;